module.exports = __webpack_public_path__ + "static/question-ad5b84e00c78e10c9a3d63c21b0e0655.png";